module.exports = __webpack_public_path__ + "static/img/topyoushi.58db309a.png";